function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useLocale, useRouteMeta, useSiteData } from 'dumi';
import Previewer from 'dumi/theme-default/builtins/Previewer';
import Device from "dumi/theme/slots/Device";
import React, { useCallback, useEffect, useState } from 'react';
import "./index.less";
var MobilePreviewer = function MobilePreviewer(props) {
  var _useRouteMeta = useRouteMeta(),
    _useRouteMeta$frontma = _useRouteMeta.frontmatter.mobile,
    mobile = _useRouteMeta$frontma === void 0 ? true : _useRouteMeta$frontma;
  var _useSiteData = useSiteData(),
    themeConfig = _useSiteData.themeConfig;
  var locale = useLocale();
  var generateUrl = useCallback(function (p) {
    var _p$demoUrl$split = p.demoUrl.split('?'),
      _p$demoUrl$split2 = _slicedToArray(_p$demoUrl$split, 2),
      pathname = _p$demoUrl$split2[0],
      search = _p$demoUrl$split2[1];
    var params = new URLSearchParams(search);
    if (p.compact) params.set('compact', '');
    if (p.background) params.set('background', p.background);
    if (locale.id) params.set('locale', locale.id);
    return "".concat(pathname, "?").concat(params.toString()).replace(/\?$/, '');
  }, []);
  var _useState = useState(function () {
      return generateUrl(props);
    }),
    _useState2 = _slicedToArray(_useState, 2),
    demoUrl = _useState2[0],
    setDemoUrl = _useState2[1];
  useEffect(function () {
    setDemoUrl(generateUrl(props));
  }, [props.compact, props.background]);
  return /*#__PURE__*/React.createElement(Previewer, _extends({}, props, {
    demoUrl: demoUrl,
    iframe: mobile ? false : props === null || props === void 0 ? void 0 : props.iframe,
    className: mobile ? 'dumi-mobile-previewer' : undefined,
    forceShowCode: mobile,
    style: {
      '--device-width': themeConfig.deviceWidth ? "".concat(themeConfig.deviceWidth, "px") : undefined
    },
    _live_in_iframe: mobile
  }), mobile && /*#__PURE__*/React.createElement(Device, {
    url: demoUrl,
    inlineHeight: typeof props.iframe === 'number' ? props.iframe : undefined
  }), !mobile && (props === null || props === void 0 ? void 0 : props.children));
};
export default MobilePreviewer;